import { watchStory } from "@/mocks/gua";

export default function WatchSection() {
  return (
    <section id="watch" className="mx-auto max-w-6xl scroll-mt-28 px-4 py-16 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-stretch lg:gap-10">
        {/* 图文并重的配图区 */}
        <div className="relative overflow-hidden rounded-lg border border-background-200 bg-background-100">
          <img
            src={watchStory.image}
            alt="吃瓜黑网争议观察专栏配图：塌房背后的三条裂缝"
            title="争议观察专栏配图"
            className="h-72 w-full object-cover lg:h-full lg:absolute lg:inset-0"
          />
          <span className="absolute bottom-3 left-3 rounded-sm bg-foreground-950/70 px-2 py-1 text-xs text-background-50 backdrop-blur">
            编辑部制图 · 概念示意
          </span>
        </div>

        {/* 专栏正文 */}
        <div className="flex flex-col">
          <p className="flex items-center gap-2 text-xs font-medium tracking-[0.3em] text-primary-600">
            <span className="inline-block h-px w-8 bg-primary-500" />
            {watchStory.kicker}
          </p>
          <h2 className="mt-4 font-display text-3xl font-black leading-snug tracking-tight text-foreground-950 md:text-4xl">
            {watchStory.title}
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">{watchStory.lead}</p>

          <ul className="mt-6 flex flex-col gap-3">
            {watchStory.points.map((p, i) => (
              <li key={p.k} className="flex items-center gap-3 rounded-md border border-background-200 bg-background-50 px-4 py-3">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-500 text-xs font-semibold text-background-50">
                  {i + 1}
                </span>
                <span className="text-sm font-medium text-foreground-800">{p.t}</span>
              </li>
            ))}
          </ul>

          <blockquote className="mt-6 border-l-2 border-primary-500 bg-primary-50/70 py-2 pl-4 pr-3">
            <p className="font-display text-lg font-semibold leading-relaxed text-foreground-900 md:text-xl">
              “{watchStory.quote}”
            </p>
          </blockquote>

          <div className="mt-auto flex flex-wrap items-center justify-between gap-3 border-t border-background-200 pt-5">
            <span className="text-xs text-foreground-500">吃瓜黑网 · 编辑部专栏 · 不接外部投放</span>
            <button
              type="button"
              className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              追更本专栏
              <i className="ri-bookmark-line" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}